<template>
  <div class="docuble-selects">
    <div class="tab-menu">
      <div class="tab-bar" ref="tabbar">
        <div class="tab-list">
          <a
            v-for="(o, index) in list"
            :key="index"
            :class="[
              'tab',
              { active: index === selectIndexTab || value[o.type] === o.value }
            ]"
            :href="o.href || 'javascript:;'"
            v-stat="o.stat"
            @click.prevent="selectIndexTab = index"
          >
            {{ o.name }}
          </a>
        </div>
      </div>
      <div class="side-menu" ref="sidemenu">
        <a
          v-for="(o, index) in secondSelected"
          :key="index"
          :class="['tab', { active: value[o.type] == o.value }]"
          @click.prevent="handleSelect(o)"
          :href="o.href || 'javascript:;'"
          v-stat="o.stat"
        >
          {{ o.name }}
        </a>
      </div>
      <div
        style="position: absolute; z-index: 99"
        @click="reset"
        class="no-limit-city"
        v-stat="resetText"
      >
        {{ resetText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectIndexTab: 0,
      selectIndexSideTab: 0
    }
  },
  props: {
    value: {
      type: Object
    },
    list: {
      type: Array,
      default: () => []
    },
    resetText: {
      type: String,
      default: '不限城市'
    }
  },
  computed: {
    secondSelected() {
      return this.list[this.selectIndexTab]?.list || []
    }
  },
  methods: {
    reset() {
      this.selectIndexTab = 0
      // this.handleSelect(this.secondSelected[0])

      const first = this.list[this.selectIndexTab]
      const item = this.secondSelected[0]
      this.$emit('change', {
        [first.type]: '',
        [item.type]: ''
      })
    },
    handleSelect(item) {
      const first = this.list[this.selectIndexTab]
      this.$emit('change', {
        [first.type]: first.value,
        [item.type]: item.value
      })
    }
  }
}
</script>

<style lang="scss">
.docuble-selects {
  .tab-menu {
    @include flex(row, flex-start, flex-start);
    font-size: 30px;
    box-sizing: border-box;
    /*padding: 50px 0;*/
    position: relative;
    .no-limit-city {
      position: absolute;
      bottom: 30px;
      right: 30px;
      width: 196px;
      height: 56px;
      color: #fff;
      z-index: 13;
      background-color: #718aff;
      border-radius: 100px;
      text-align: center;
      line-height: 56px;
      font-size: 26px;
    }
    .tab-bar {
      width: 240px;
      height: 900px;
      overflow-y: scroll;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      @include flex(column, flex-start, center);
      background-color: #f1f5f9;
      .tab-list {
        width: 100%;
        .tab {
          display: block;
          width: 100%;
          padding-left: 50px;
          height: 90px;
          line-height: 90px;
          color: #6c798c;
          overflow: hidden;
          &.active {
            background-color: #fff;
            color: #718aff;
          }
        }
      }
    }
    .side-menu {
      flex: 1;
      @include flex(column, flex-start, flex-start);
      font-size: 30px;
      background-color: #fff;
      color: #718aff;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 80px;
      height: 800px;
      /*overflow: hidden;*/

      overflow: scroll;
      overflow-x: hidden;
      box-sizing: border-box;
      /*position: relative;*/

      .tab {
        width: 100%;
        height: 90px;
        line-height: 90px;
        display: block;
        color: #333;
        margin-left: 72px;
        position: relative;
        .cur-location {
          position: absolute;
          color: #6c798c;
          bottom: -36px;
          font-size: 24px;
        }
        &.active {
          color: #718aff;
        }
        .yxlicon {
          font-size: 24px;
          position: absolute;
          left: -10px;
          transform: translateX(-100%);
        }
      }
    }
  }
}
</style>
